var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Logo"},[_c('div',{staticClass:"LogoImg",class:[{}, _vm.variation],style:({
      width: _vm.size + 'px'
    })})])
}
var staticRenderFns = []

export { render, staticRenderFns }